import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout.vue'
import AuthLayout from '@/pages/Dashboard/Pages/AuthLayout.vue'

// Dashboard pages
import Dashboard from '@/pages/Dashboard/Dashboard.vue'

// Pages
const User = () =>
    import ('@/pages/Dashboard/Pages/UserProfile.vue');

const UserSettings = () =>
    import ('@/pages/Dashboard/Pages/UserSettings.vue');

const TimeLine = () =>
    import ('@/pages/Dashboard/Pages/TimeLinePage.vue');
const RtlSupport = () =>
    import ('@/pages/Dashboard/Pages/RtlSupport.vue');
const Login = () =>
    import ('@/pages/Dashboard/Pages/Login.vue');
const ForgotPassword = () =>
  import ('@/pages/Dashboard/Pages/ForgotPassword.vue');
const PasswordResetRequested = () =>
  import ('@/pages/Dashboard/Pages/PasswordResetRequested.vue');
const Signup = () =>
  import ('@/pages/Dashboard/Pages/Signup.vue');
const Register = () =>
    import ('@/pages/Dashboard/Pages/Register.vue');
const Lock = () =>
    import ('@/pages/Dashboard/Pages/Lock.vue');
const UserNotFound = () =>
    import ('@/pages/Dashboard/Pages/UserNotFound.vue');
const Cart = () =>
    import ('@/pages/Dashboard/Pages/Cart.vue');
const EnvironmentClosed = () =>
    import('@/pages/Dashboard/Pages/EnvironmentClosed.vue');

// Components pages
const Buttons = () =>
    import ('@/pages/Dashboard/Components/Buttons.vue');
const GridSystem = () =>
    import ('@/pages/Dashboard/Components/GridSystem.vue');
const Panels = () =>
    import ('@/pages/Dashboard/Components/Panels.vue');
const SweetAlert = () =>
    import ('@/pages/Dashboard/Components/SweetAlert.vue');
const Notifications = () =>
    import ('@/pages/Dashboard/Components/Notifications.vue');
const Icons = () =>
    import ('@/pages/Dashboard/Components/Icons.vue');
const Typography = () =>
    import ('@/pages/Dashboard/Components/Typography.vue');

// Endpoints pages
const API = () =>
    import ('@/pages/Dashboard/Pages/Endpoints/API.vue');
const Sites = () =>
    import ('@/pages/Dashboard/Pages/Endpoints/Sites.vue');

const Content = () =>
    import ('@/pages/Dashboard/Pages/Content.vue');

const Cards = () =>
    import ('@/pages/Dashboard/Pages/Cards.vue');

const Data = () =>
    import ('@/pages/Dashboard/Pages/Data.vue');

const Users = () =>
    import ('@/pages/Dashboard/Pages/Users.vue');

// Environment pages
const Settings = () =>
    import ('@/pages/Dashboard/Pages/Environment/Settings.vue');

// Calendar
const Calendar = () =>
    import ('@/pages/Dashboard/Calendar.vue');
// Charts
const Charts = () =>
    import ('@/pages/Dashboard/Charts.vue');

import Widgets from '@/pages/Dashboard/Widgets.vue';

let componentsMenu = {
    path: '/components',
    component: DashboardLayout,
    redirect: '/components/buttons',
    name: 'Components',
    children: [{
            path: 'buttons',
            name: 'Buttons',
            components: {
                default: Buttons
            }
        },
        {
            path: 'grid-system',
            name: 'Grid System',
            components: {
                default: GridSystem
            }
        },
        {
            path: 'panels',
            name: 'Panels',
            components: {
                default: Panels
            }
        },
        {
            path: 'sweet-alert',
            name: 'Sweet Alert',
            components: {
                default: SweetAlert
            }
        },
        {
            path: 'notifications',
            name: 'Notifications',
            components: {
                default: Notifications
            }
        },
        {
            path: 'icons',
            name: 'Icons',
            components: {
                default: Icons
            }
        },
        {
            path: 'typography',
            name: 'Typography',
            components: {
                default: Typography
            }
        }

    ]
}

let pagesMenu = {
    path: '/pages',
    component: DashboardLayout,
    name: 'Pages',
    redirect: '/pages/user',
    children: [{
            path: 'user',
            name: 'User Page',
            components: {
                default: User
            }
        },
        {
            path: 'usersettings',
            name: 'User Settings',
            components: {
                default: UserSettings
            }
        },
        {
            path: 'timeline',
            name: 'Timeline Page',
            components: {
                default: TimeLine
            }
        },
        {
            path: 'rtl',
            name: 'وحة القيادة',
            meta: {
                rtlActive: true
            },
            components: {
                default: RtlSupport
            }
        }
    ]
}

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [{
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/lock',
            name: 'Lock',
            component: Lock
        }
    ]
}

let endpointsMenu = {
    path: '/endpoints',
    component: DashboardLayout,
    name: 'Endpoints',
    children: [{
            path: 'api',
            name: 'API',
            components: {
                default: API
            }
        },
        {
            path: 'sites',
            name: 'Sites',
            components: {
                default: Sites
            }
        }
    ]
}

let contentMenu = {
    path: '/content',
    component: DashboardLayout,
    name: 'content',
    redirect: '/content',
    children: [{
        path: '/content',
        name: 'Content',
        components: {
            default: Content
        }
    },
      {
        path: '/content/:cartId/',
        name: 'SharedCartContent',
        components: {
          default: Content
        },
      }]
}

let cardsMenu = {
    path: '/cards',
    component: DashboardLayout,
    name: 'cards',
    redirect: '/cards',
    children: [{
        path: '/cards',
        name: 'Cards',
        components: {
            default: Cards
        }
    }]
}

let dataMenu = {
    path: '/data',
    component: DashboardLayout,
    name: 'data',
    redirect: '/data',
    children: [{
        path: '/data',
        name: 'Data',
        components: {
            default: Data
        }
    }]
}

let cartMenu = {
    path: '/cart',
    component: DashboardLayout,
    name: 'cart',
    redirect: '/cart',
    children: [{
        path: '/cart',
        name: 'Cart',
        components: {
            default: Cart
        }
    },
      {
        path: '/cart/:id/:loadCartItems',
        name: 'SharedCart',
        components: {
          default: Cart
        },
      }]
}

let usersMenu = {
    path: '/users',
    component: DashboardLayout,
    name: 'users',
    redirect: '/users',
    children: [{
        path: '/users',
        name: 'Users',
        components: {
            default: Users
        }
    }]
}

let environmentMenu = {
    path: '/environment',
    component: DashboardLayout,
    name: 'environment',
    redirect: '/environment/settings',
    children: [{
        path: 'settings',
        name: 'Settings',
        components: {
            default: Settings
        }
    }]
}

let login = {
    path: '/login',
    name: 'login',
    component: Login,
}

let forgotPassword = {
  path: '/forgotpassword',
  name: 'forgotPassword',
  component: ForgotPassword,
}

let passwordResetRequested = {
  path: '/passwordResetRequested',
  name: 'passwordResetRequested',
  component: PasswordResetRequested,
}

let signup = {
  path: '/signup',
  name: 'signup',
  component: Signup,
}

let notFound = {
    path: '/usernotfound',
    component: UserNotFound,
    name: 'NotFound'

}

let environmentClosed = {
    path: '/environment-closed',
    component: EnvironmentClosed,
    name: 'EnvironmentClosed'
}

let token = {
    path: '/id_token',
    name: 'token',
    beforeEnter() { }
}
const routes = [{
        path: '/',
        redirect: '/dashboard',
        name: 'Home'
    },
    login,
    forgotPassword,
    passwordResetRequested,
    signup,
    notFound,
    environmentClosed,
    token,
    endpointsMenu,
    contentMenu,
    cardsMenu,
    dataMenu,
    usersMenu,
    pagesMenu,
    cartMenu,
    componentsMenu,
    authPages,
    environmentMenu,
    {
        path: '/',
        component: DashboardLayout,
        children: [{
                path: 'dashboard',
                name: 'Dashboard',
                components: {
                    default: Dashboard
                }
            },
            {
                path: 'calendar',
                name: 'Calendar',
                components: {
                    default: Calendar
                }
            },
            {
                path: 'charts',
                name: 'Charts',
                components: {
                    default: Charts
                }
            },
            {
                path: 'widgets',
                name: 'Widgets',
                components: {
                    default: Widgets
                }
            }
        ]
    }
];

export default routes
